import React, { useRef } from "react";
import { connect } from "react-redux";
import { WebsitePagesState } from "../store/websitePages/types";
import _ from "lodash";
import { getCurrentStoreData } from "../store/websites/thunks";
import { GetCurrentStoreData } from "../store/websites/types";
import ClipboardJS from "clipboard";
import { Alert, Dropdown, Icon, Menu, message, Tooltip } from "antd";
import { Button } from "antd";

interface Props {
  websitesPages: WebsitePagesState;
  getCurrentStoreData: GetCurrentStoreData;
}
const AvailableGlobalPropsInline = (props: Props) => {
  const { websitesPages, getCurrentStoreData } = props;
  const { currentWebsitePage } = getCurrentStoreData();
  if (!currentWebsitePage) return null;
  const clipboardRef = useRef(null);

  const columns = (
    _.get(websitesPages, [
      "pageDynamicData",
      currentWebsitePage.id,
      "columns",
    ]) || []
  ).sort((a, b) => {
    if (typeof a !== "string" || typeof b !== "string") {
      return 0;
    }
    const priorityOrder = [
      "title",
      "name",
      "subtitle",
      "description",
      "text",
      "about",
      "message",
      "url",
      "link",
      "avatar",
      "img",
      "image",
      "imgurl",
    ];
    const strA = a.toLowerCase();
    const strB = b.toLowerCase();
    const indexA = priorityOrder.indexOf(strA);
    const indexB = priorityOrder.indexOf(strB);
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) {
      return -1;
    }
    if (indexB !== -1) {
      return 1;
    }
    return strA.localeCompare(strB);
  });

  if (columns.length === 0) {
    return null;
  }

  const previewColumns = columns.slice(0, 5);
  const otherColumns = columns.slice(5);

  const previewResults = previewColumns.map((column, i) => {
    const buttonId = `field-button-preview-${i}`;
    clipboardRef.current = new ClipboardJS(`#${buttonId}`);
    return (
      <Button
        size="small"
        data-clipboard-target={`#${buttonId}`}
        id={buttonId}
        style={{
          userSelect: "all",
        }}
        onClick={() => {
          message.success("Copied to clipboard", 2);
        }}
        key={`preview-${i}`}
      >
        {`{{$${column}}}`}
      </Button>
    );
  });

  const otherColumnsMenu = otherColumns.map((column, i) => {
    const buttonId = `field-button-more-${i}`;
    clipboardRef.current = new ClipboardJS(`#${buttonId}`);
    return (
      <Menu.Item
        key={`more-${i}`}
        onClick={() => {
          message.success("Copied to clipboard", 2);
        }}
        id={buttonId}
        style={{
          userSelect: "all",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        data-clipboard-target={`#${buttonId}`}
      >
        {`{{$${column}}}`}
      </Menu.Item>
    );
  });

  return (
    <li className="content-input" key="global-props-inline">
      <h2 className="content-input__title">
        Available properties
        <Tooltip
          placement="top"
          title={
            <div>
              Available global properties for this dynamic page. Insert them into
              the content to display data from your CMS.{" "}
              <a
                href="https://help.unicornplatform.com/en/article/dynamic-data-from-api-source-fazl04/"
                target="_blank"
                className="content-input__tooltip-link"
              >
                Learn more
              </a>
            </div>
          }
        >
          <Icon className="content-input__tooltip_icon" type="info-circle" />
        </Tooltip>
      </h2>
      <Alert
        style={{
          borderRadius: 8,
          borderColor: "#E8E8E8",
          background: "#FAFAFA",
          padding: 8,
        }}
        message={
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {previewResults}
            {otherColumns.length > 0 && (
              <Dropdown
                overlay={
                  <Menu
                    style={{ maxHeight: 214, overflow: "auto", width: 200 }}
                  >
                    {otherColumnsMenu}
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button size="small">
                  <Icon type="down" style={{ marginRight: -3 }} />
                  {otherColumns.length} more
                </Button>
              </Dropdown>
            )}
          </div>
        }
      />
    </li>
  );
};

const mapStateToProps = (state: any) => {
  return {
    websitesPages: state.websitesPages,
  };
};

export default connect(mapStateToProps, { getCurrentStoreData })(
  AvailableGlobalPropsInline
);
